import { Allergen } from '@/types/allergen';
import { AllergenWire } from '../schemas/allergen';

/**
 * Convert wire allergen format (backend) to domain allergen format (app).
 * Handles type conversions: ISO strings -> Unix ms, 0/1 -> boolean,
 * null -> undefined. Returns a new object; never mutates the input.
 */
export function mapAllergenWireToDomain(wire: AllergenWire): Allergen {
  return {
    id: wire.id,
    name: wire.name,
    slug: wire.slug,
    description: wire.description ?? undefined, // Convert null to undefined
    isCurated: wire.is_curated === 1,
    isFdaBigNine: wire.is_fda_big_nine === 1,
    createdAt: new Date(wire.created_at).getTime(),
    updatedAt: new Date(wire.updated_at).getTime(),
  };
}
